<template>
  <div class="container d-flex flex-wrap mt-5 mb-2">
            <iframe class="col-lg-5 col-md-6 col-sm-12 nch--iframe-box px-0" width="100%" height="315" :src="video.src" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen>
            </iframe>
            <div class="col-lg-7 col-md-6 col-sm-12 mt-4 text-center">
                <h1 class="mb-0 mt-3 mx-3">{{video.translation.title}}</h1>
                <p class="my-3 mx-3 text-justify text-center">{{video.translation.description}}</p>
            </div>
        </div>
</template>

<script>

export default {
    name: "PlansDetailsVideo",
    props: {
        video: {
            type: Object,
            required: true
        }
    }
}
</script>

<style>

</style>